// extracted by mini-css-extract-plugin
export default {"select":"ScaleSelector_select__+Q7FJ","rounded":"ScaleSelector_rounded__zhDYg"};